import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/modal';
import ResearchPropertySelector from 'components/research_property/research_property_select';
import { Button } from 'components/ui/button';
import { Errors } from 'components/ui/errors';

export default function ResearchPropertyModal({ show, onConnect, onHide }) {
  const [connecting, setConnecting] = useState(false);
  const [property, setProperty] = useState(null);
  const [errors, setErrors] = useState([]);

  const handleConnect = async () => {
    setConnecting(true);
    setErrors([]);

    try {
      await onConnect(property.value);
      onHide();
    } catch (error) {
      setErrors(error);
    } finally {
      setConnecting(false);
    }
  };

  const handleExited = () => {
    setErrors([]);
    setProperty(null);
  };

  return (
    <Modal
      className="overflow-visible"
      show={show}
      onExited={handleExited}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        Connect Property
      </Modal.Header>
      <Modal.Body className="d-flex flex-column gap-3">
        <Errors errors={errors} title="Unable to connect property" />
        <div>
          <label className="mb-1 form-label">Search Properties</label>
          <ResearchPropertySelector placeholder="Search name or address" onModelAdded={setProperty} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onHide} />
        <Button disabled={!property || connecting} label="Connect" onClick={handleConnect} />
      </Modal.Footer>
    </Modal>
  );
}

ResearchPropertyModal.propTypes = {
  show: PropTypes.bool,
  onConnect: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};
